import { render, staticRenderFns } from "./TaskBlockCommentAction.vue?vue&type=template&id=1f521292&"
import script from "./TaskBlockCommentAction.vue?vue&type=script&lang=js&"
export * from "./TaskBlockCommentAction.vue?vue&type=script&lang=js&"
import style0 from "./TaskBlockCommentAction.vue?vue&type=style&index=0&id=1f521292&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f521292')) {
      api.createRecord('1f521292', component.options)
    } else {
      api.reload('1f521292', component.options)
    }
    module.hot.accept("./TaskBlockCommentAction.vue?vue&type=template&id=1f521292&", function () {
      api.rerender('1f521292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Task/TaskBlockCommentAction.vue"
export default component.exports